import { HttpContext, HttpContextToken } from '@angular/common/http';

export type ApiErrorPresentationPolicy =
  | { mode: 'generic'; fallback?: string }
  | { mode: 'rich'; audience: 'all' | 'asm'; fallback: string }
  | { mode: 'feature' };

export const API_ERROR_PRESENTATION =
  new HttpContextToken<ApiErrorPresentationPolicy>(() => ({
    mode: 'generic',
  }));

export function genericApiErrorContext(fallback?: string): HttpContext {
  return new HttpContext().set(API_ERROR_PRESENTATION, {
    mode: 'generic',
    fallback,
  });
}

export function richApiErrorContext(options: {
  audience: 'all' | 'asm';
  fallback: string;
}): HttpContext {
  return new HttpContext().set(API_ERROR_PRESENTATION, {
    mode: 'rich',
    ...options,
  });
}

export function featureHandledErrorContext(): HttpContext {
  return new HttpContext().set(API_ERROR_PRESENTATION, { mode: 'feature' });
}
